"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.string = void 0;

var Converters_1 = require("../check/arbitrary/definition/Converters");

var array_1 = require("./array");

var char_1 = require("./char");

var StringConstraintsExtractor_1 = require("./_internals/helpers/StringConstraintsExtractor");

var CodePointsToString_1 = require("./_internals/mappers/CodePointsToString");

function string() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var constraints = (0, StringConstraintsExtractor_1.extractStringConstraints)(args);
  return (0, Converters_1.convertFromNext)((0, Converters_1.convertToNext)((0, array_1.array)((0, char_1.char)(), constraints)).map(CodePointsToString_1.codePointsToStringMapper, CodePointsToString_1.codePointsToStringUnmapper));
}

exports.string = string;